var tmp_deal = '<p class="prod-sale-derection">This product is currently on deal discount, please <a href="<%=url%>" target="_blank">Claim the discount</a> for much cheaper price.</p>';
var tmp_clearance = '<p class="prod-sale-derection">This product is currently on clearance discount, please <a href="<%=url%>" target="_blank">Claim the discount</a> for much cheaper price.</p>';
var tmp_giveaway = '<p class="prod-sale-derection">There are giveaways events on this product, please <a href="<%=url%>" target="_blank">Check details</a></p>';
$(function()
{
  CloudZoom.quickStart();
  $("[data-tab]").click(function()
  {
    var tabName = $(this).attr("data-tab");
    var tab = $(_.template("[data-tab-content='<%=tabName%>']")({tabName:tabName}));

    $(this).siblings().removeClass("prod-panel-active");
    $(this).addClass("prod-panel-active");
    tab.siblings("[data-tab-content]").hide();
    tab.show();
  });

  var count = $("#imageMenu li").length - 3; /* 显示 6 个 li标签内容 */
	
  var interval = $("#imageMenu li:first").outerWidth() + 4;

  var curIndex = 0;

  $('.scrollbutton').click(function() {
	if(!$("#imageMenu ul").is(':animated'))
    {
      if($(this).hasClass('disabled')) return false;

      if($(this).hasClass('buttonPev')) --curIndex;

      else ++curIndex;

      if(curIndex == -1) {
        curIndex = 0;
        return false;
      }else if(curIndex == count){
        curIndex = count-1;
        return false;
      }

      $("#imageMenu ul").animate({
        "marginLeft": -curIndex * interval + "px"
      }, 300);
    }
  });
  
  $("li", "#imageMenu").click(function()
  {
    $(this).siblings().removeClass("imgBorder");
    $(this).addClass("imgBorder");
    
    var fullW = $("#imageMenu").width();
    var viewCount = Math.ceil(fullW / $("#imageMenu li:first").outerWidth(true));
    var curViewIndex = curIndex + viewCount - 1;
    var curSelIndex = $(this).index();

    if(curSelIndex == curViewIndex)
    {
      $(".buttonNext").click();
    }
    else if(curSelIndex == curIndex)
    {
      $(".buttonPev").click();
    }
  });
  
  var handle = $(".prod-container").attr("data-handle");
  var id = $(".prod-container").attr("data-id");
  $.ajax(control.constants.webapi_url + "/deals/getDealsAndGivesByShopifyInfo",
  {
    method:"post",
    contentType: "application/json",
    data: JSON.stringify({shopifyInfos: [{shopifyProductHandle: handle, shopifyProductId:id}]}),
    success: function(data)
    {
      var html = "";
      $.each(data.result, function(i, v)
      {
        if(v.amazonDeals && v.amazonDeals.length)
        {
          var url = deals_url + "?id=" + v.amazonDeals[0].id + "&mkt=" + v.amazonDeals[0].marketPlaceId + "&type=10";
          html += _.template(tmp_deal)({url: url});
        }
        
        if(v.clearance && v.clearance.length)
        {
          var url = deals_url + "?id=" + v.clearance[0].id + "&mkt=" + v.clearance[0].marketPlaceId + "&type=20";
          html += _.template(tmp_clearance)({url: url});
        }
        
        if(v.giveaways && v.giveaways.length)
        {
          var url = deals_url + "?id=" + v.giveaways[0].id + "&mkt=" + v.giveaways[0].marketPlaceId + "&type=30";
          html += _.template(tmp_giveaway)({url: url});
        }
      });
      
      if(!_.isEmpty(html))
      {
        $(".prd-deals").append(html);
        $(".prd-deals").show();
      }
    }
  });
});